import React from "react";

/**
 * SectionDivider - a lotus / mandala inspired divider used between sections.
 * Variant "lotus" | "mandala" | "arch".
 */
const SectionDivider = ({ variant = "lotus", className = "" }) => {
  return (
    <div className={`flex items-center justify-center py-10 sm:py-14 ${className}`} aria-hidden="true">
      <span className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-transparent to-[#D4AF37]/50" />
      <div className="mx-6">
        {variant === "lotus" && (
          <svg width="46" height="30" viewBox="0 0 46 30" fill="none">
            <path d="M23 28 C 12 22, 6 12, 23 4 C 40 12, 34 22, 23 28 Z" stroke="#D4AF37" strokeWidth="1" fill="rgba(201,162,39,0.08)" />
            <path d="M23 26 C 15 20, 12 12, 23 8 C 34 12, 31 20, 23 26 Z" stroke="#B65A14" strokeWidth="0.7" fill="none" />
            <circle cx="23" cy="16" r="1.6" fill="#B65A14" />
          </svg>
        )}
        {variant === "mandala" && (
          <svg width="34" height="34" viewBox="0 0 34 34">
            <circle cx="17" cy="17" r="14" stroke="#D4AF37" strokeWidth="0.8" fill="none" />
            <circle cx="17" cy="17" r="9" stroke="#D4AF37" strokeWidth="0.6" fill="none" strokeDasharray="2 2" />
            <circle cx="17" cy="17" r="3" fill="#B65A14" />
            {Array.from({ length: 8 }).map((_, i) => (
              <line key={i} x1="17" y1="17" x2="17" y2="3" stroke="#D4AF37" strokeWidth="0.5" transform={`rotate(${i * 45} 17 17)`} />
            ))}
          </svg>
        )}
        {variant === "arch" && (
          <svg width="70" height="24" viewBox="0 0 70 24">
            <path d="M2 22 Q 35 -8 68 22" stroke="#D4AF37" strokeWidth="1" fill="none" />
            <path d="M8 22 Q 35 -2 62 22" stroke="#B65A14" strokeWidth="0.7" fill="none" />
            <circle cx="35" cy="8" r="1.5" fill="#B65A14" />
          </svg>
        )}
      </div>
      <span className="h-px flex-1 max-w-[120px] bg-gradient-to-l from-transparent to-[#D4AF37]/50" />
    </div>
  );
};

export default SectionDivider;
